<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-3 px-2">
  <div class="sticky top-0 z-10 bg-white dark:bg-coal-500 mb-1">
    <div class="flex flex-col gap-1 items-start rounded-lg mb-1">
      <label
        *ngIf="fields.displayName || isDependencySelected"
        [class.required]="isDependencySelected"
        class="text-2sm font-semibold text-gray-700 mb-0"
        [for]="fields.fieldName"
      >
        {{ fields.displayName || 'Platforms' }}
      </label>
      <div class="flex search-wrapper rounded w-full" *ngIf="isDependencySelected">
        <label
          [ngClass]="{
            'border-danger': formGroup.get(fields.fieldName)?.touched && formGroup.get(fields.fieldName)?.invalid
          }"
          class="input flex items-center w-full cursor-pointer border border-gray-300 dark:border-gray-600 rounded-md transition-all duration-150"
        >
          <i class="ki-filled ki-magnifier text-gray-500 ms-3"> </i>
          <input
            searchInput
            type="text"
            #searchInput
            (input)="onKeyUpSearch(searchInput.value)"
            class="w-full text-2sm p-2 border-none outline-none bg-transparent text-gray-500"
            [placeholder]="fields.placeholder"
          />
          <button
            *ngIf="searchInput.value"
            type="button"
            class="clear-btn text-xl text-gray-600 dark:text-gray-300 me-3"
            (click)="resetSearch()"
          >
            ×
          </button>
        </label>
      </div>
    </div>
  </div>
  <div class="mt-4 h-300px overflow-y-auto">
    <!-- ✅ SKELETON -->
    <div class="user-skeleton-list" *ngIf="isLoading">
      <div
        class="user-skeleton-row border border-gray-200 p-2 rounded-md"
        *ngFor="let i of [1, 2, 3, 4, 5]"
      >
        <div class="radio shimmer-item bg-gray-300 dark:bg-coal-700"></div>
        <div class="avatar shimmer-item bg-gray-300 dark:bg-coal-700"></div>

        <div class="details">
          <div class="name shimmer-item bg-gray-300 dark:bg-coal-700"></div>
        </div>
        <div
          class="shimmer-item bg-gray-300 dark:bg-coal-700 h-20px w-60px rounded"
        ></div>
      </div>
    </div>
    <ng-container *ngIf="fieldsData.length === 0 && !isLoading && !isDependencySelected">
      <div class="flex justify-center items-center h-full w-full py-10">
        <div class="flex justify-center items-center flex-col text-center">
          <div class="bg-gray-100 dark:bg-coal-700 h-16 w-16 rounded-full flex items-center justify-center mb-4">
            <i class="ki-filled ki-setting-2 text-3xl text-gray-500 dark:text-gray-400"></i>
          </div>
          <span class="text-sm font-semibold text-gray-900 dark:text-gray-200">Select a Control</span>
          <span class="text-xs text-gray-500 mt-1 max-w-[250px]"
            >Please select a control from the dropdown above to view available integrations.</span
          >
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="fieldsData.length === 0 && !isLoading && isDependencySelected">
      <div class="flex justify-center items-center h-full w-full py-10">
        <div class="flex justify-center items-center flex-col text-center">
          <div class="bg-gray-100 dark:bg-coal-700 h-16 w-16 rounded-full flex items-center justify-center mb-4">
            <i class="ki-filled ki-magnifier text-3xl text-gray-500 dark:text-gray-400"></i>
          </div>
          <span class="text-sm font-semibold text-gray-900 dark:text-gray-200">No integrations found</span>
          <span class="text-xs text-gray-500 mt-1 max-w-[250px]"
            >There are no integrations available for the selected control or search query.</span
          >
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="fieldsData.length > 0 && !isLoading">
      <div *ngFor="let option of fieldsData; let i = index; trackBy: trackById">
        <label
          class="flex items-center cursor-pointer rounded-md transition-colors duration-200 hover:bg-secondary-active p-3 border border-gray-200 mb-2"
        >
          <!-- Select Integration -->
          <input
            type="checkbox"
            class="checkbox checkbox-2sm me-3 cursor-pointer"
            [checked]="isSelected(option)"
            (change)="selectIntegration(option, $event)"
          />

          <!-- Integration Icon -->
          <img
            *ngIf="option.iconUrl"
            [src]="option.iconUrl"
            [alt]="option.name"
            class="w-7 h-7 rounded me-3"
          />

          <!-- Integration Name -->
          <div class="flex flex-col flex-1">
            <span class="font-semibold text-2sm text-gray-900">
              {{ option.name }}
            </span>
          </div>

          <!-- Status Badge -->
          <span
            [ngClass]="{
              'badge-success': option.status === 'Connected',
              'badge-secondary': option.status === 'Disconnected',
            }"
            class="badge badge-sm badge-outline rounded-md"
          >
            {{ option.status }}
          </span>
        </label>
      </div>
    </ng-container>
  </div>
  <div *ngIf="showError" class="text-danger text-sm mt-1">
    Please select integration
  </div>
</div>
